import { keepPreviousData, useQuery } from '@tanstack/react-query';
import mcpUsuariosService from '../services/mcpUsuariosService';
import { mcpUsuariosKeys } from '../queryKeys';

const VACIO = { data: [], truncado: false };

const useMcpUsuariosLista = ({ headquarter, search = '', estado }) =>
  useQuery({
    queryKey: mcpUsuariosKeys.lista(headquarter, { search, estado }),
    queryFn: async () => {
      const res = await mcpUsuariosService.listar({ headquarter, search, estado });
      return Array.isArray(res?.data) ? { data: res.data, truncado: Boolean(res.truncado) } : VACIO;
    },
    enabled: Boolean(headquarter),
    staleTime: 30 * 1000,
    placeholderData: keepPreviousData,
    // Un 403 (no gestor) no se arregla reintentando.
    retry: (intentos, error) => error?.response?.status !== 403 && intentos < 2,
  });

export default useMcpUsuariosLista;
